import React from "react";
import GameLayout from "../../layouts/GameLayout";

export function Game() {
    return <GameLayout />;
}

